import styled from "styled-components";
import { media } from "../../theme/theme";
import { V3CaptionGrey35 } from "../ReusableStyledComponents/V3CaptionGrey35";

export const V3EmbedModalLayout = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    ${media.tablet} {
        flex-direction: row;
    }

    > div {
        &:first-child {
            align-self: flex-start;
            width: 100%;
            margin-bottom: 24px;

            ${media.tablet} {
                width: 330px;
                align-self: center;
                margin-bottom: 0;
            }
        }

        &:nth-child(2) {
            ${media.tablet} {
                width: calc(100% - 394px);
                max-height: 70vh;
                overflow: auto;
            }
        }
    }
`;

export const V3ShowCodeWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const V3EmbedRadioInputs = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    > div {
        width: calc(50% - 6px);
    }
`;

export const EmbedRightSidePanel = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;

    ${V3CaptionGrey35} {
        max-width: 380px;
        margin: 0 auto;
        text-align: center;
    }

    > div {
        width: 100%;
    }
`;